import _ from 'underscore';
import Backbone from 'backbone';
import { state } from '../state-manager/state-model';
import { eventBus } from '../state-manager/event-bus';
import { ERRORS } from '../utils/handle-error';
import { toTextTags, toText, toShort, addComma } from '../utils/number-format';

function getMembershipName(membership, hasSubscription) {
  var suffix = hasSubscription ? '(정기)' : '(개월)';

  switch (membership) {
    case 'silverclass':
      return '실버클래스' + suffix;
    case 'goldclass':
      return '골드클래스' + suffix;
    default:
      return '미보유';
  }
}

// function getSuddaVipGrade(grade) {
//   switch (grade) {
//     case 1:
//       return '퍼플';
//     case 2:
//       return '블랙';
//     case 3:
//       return '레드';
//     case 4:
//       return '그린';
//     default:
//       return '일반';
//   }
// }

var UserInfoModel = Backbone.Model.extend({
  url: 'user-info',

  initialize: function () {
    this.eventBus = eventBus;
    this.on('sync', this.assertAccount, this);
    this.nwToken = $.cookie('nw_access_token');
  },

  assertAccount: function () {
    var err;
    var currentToken = $.cookie('nw_access_token');

    if (this.nwToken && this.nwToken !== currentToken) {
      err = new Error('Login information mismatched');
      err.code = ERRORS.InvalidSignedDate;
      this.eventBus.trigger('app:handleError', err);
    }
  },

  populateModel: function (attrs) {
    var asset = attrs.asset;
    var profile = attrs.profile;

    /** 회원정보 */
    var hasSubscription = profile.hasSubscription;
    var membershipText = getMembershipName(profile.membership, hasSubscription);
    var vipGrade = profile.vipGradeName || '일반';

    /** 내 보유 골드 */
    var totalMoneyTag = toTextTags(toShort(asset.totalMoney));
    var moneyTag = toTextTags(toShort(asset.money));
    var moneyInSafeTag = toTextTags(toShort(asset.moneyInSafe));
    var hasMoneySafebox = asset.moneyInSafeLimit > 0; // NOTE: safe_money_limit(금고 머니 한도)

    /** 보험금 */
    var moneyInsuranceText = toText(toShort(asset.moneyInsurance));

    /** 포커칩 */
    var totalPchipTag = toTextTags(toShort(asset.totalPchip));
    var pchipTag = toTextTags(asset.pchip);
    var hasPchipSafebox = asset.pchipInSafeLimit > 0; // NOTE: 포커칩 금고 한도
    var pchipInSafeTag = toTextTags(toShort(asset.pchipInSafe));
    var pchipHiddenTag = toTextTags(asset.pchipHidden);
    var canWithdrawPchip = asset.pchipHidden >= 100000; // && asset.pchip < 100000 // NOTE: 10만
    var canDepositPchip = !canWithdrawPchip; //asset.pchip >= 110000 && asset.pchipHidden < 1 // NOTE: 11만

    /** 피망캐쉬 */
    var pmangCashComma = addComma(asset.pmangCash);

    /** 피망 보너스 */
    var bonusPointText = addComma(asset.bonusPoint) + '점';

    return {
      game: state.get('game'),
      gameName: state.get('gameName'),
      nickname: profile.nickname || state.get('nickname'),

      membership: profile.membership,
      membershipText: membershipText,
      hasSubscription: hasSubscription,
      vipGrade: vipGrade,

      totalMoneyTag: totalMoneyTag,
      moneyTag: moneyTag,
      moneyInSafeTag: moneyInSafeTag,
      hasMoneySafebox: hasMoneySafebox,
      moneyInsuranceText: moneyInsuranceText,

      totalPchipTag: totalPchipTag,
      pchipTag: pchipTag,
      hasPchipSafebox: hasPchipSafebox,
      pchipInSafeTag: pchipInSafeTag,
      pchipHiddenTag: pchipHiddenTag,
      canWithdrawPchip: canWithdrawPchip,
      canDepositPchip: canDepositPchip,

      pmangCashComma: pmangCashComma,

      bonusPointText: bonusPointText
    };
  },

  parse: function (res) {
    var result = res.result;
    var asset = result.asset;
    var moneyLoss = result.moneyLoss;
    var profile = result.profile;
    var session = result.session; // TODO: 이거 뭐지? 누가 추가했지?

    this.updateAppState(result);

    asset.totalMoney = asset.money + asset.moneyInSafe;
    asset.totalPchip = asset.pchip + asset.pchipInSafe;

    return _.extend(
      {},
      { session: session },
      asset,
      moneyLoss,
      profile,
      this.populateModel({
        asset: asset,
        moneyLoss: moneyLoss,
        profile: profile
      })
    );
  },

  refresh: function () {
    this.fetch({ game: state.get('game') });
  },

  updateAppState: function (result) {
    state.save({
      membership: result.profile.membership,
      membershipRemaining: result.profile.membershipDaysLeft,
      vipGrade: result.profile.vipGrade,
      // NOTE: 신규 유저는 닉네임과 프로필 이미지가 없음. 게임을 실행하면 생김
      nru: !result.profile.nickname && !result.profile.src
    });
  }
});

export var userInfo = new UserInfoModel();
